import React, { Component } from "react";
import styled from "styled-components";

const MainWrapper = styled.div`
  position:relative;
  width:285px;
`;
const TooltipText=styled.span`
  visibility: hidden;
  width: 160px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
  &:after{
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`;
const Tooltip = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-block;
  padding: 2px 10px;
  font-weight: bold;
  margin: 0px 5px;
  border-radius: 100%;
  border: 1px solid gray;
  color: gray;
  &:hover ${TooltipText}{
    visibility: visible;
  } 
`;
const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 34px;
  :before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;
const MasterInput = styled.input`
  :checked+${Slider} {
    background-color: #2c7023;
  }
  :focus+${Slider} {
    box-shadow: 0 0 1px #1B9F4E;
  }
  :checked+${Slider}::before {
    transform: translateX(26px);
  }
`;
const SlaveInput = styled.input`
  :checked+${Slider} {
    background-color: #1B9F4E;
  }
  :focus+${Slider} {
    box-shadow: 0 0 1px #1B9F4E;
  }
  :checked+${Slider}::before {
    transform: translateX(26px);
  }
`;
const Toggle = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
  ${MasterInput},${SlaveInput} {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
`;
const CardContainer=styled.div`
background: white;
/* box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24); */
box-shadow: 0 4px 4px rgba(0,0,0,0.12), 0 4px 2px rgba(0,0,0,0.12);
border-radius: 5px;
border: none;
padding:10px;
`;
const MasterToggle=styled(CardContainer)`
display: flex;
background-color: #1B9F4E;
margin: 10px 0px;
color: white;
justify-content:center;
`;
const CardWrapper=styled.div`
  display:flex;
  justify-content:space-between;
  border-bottom: 0.1px solid #ccc;
  padding: 10px 0px;
`;
const Title =styled.div`
  display: flex;
`;
const OverlayBlock = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top:0;
  background: rgba(0, 0, 0, 0.2);
  /* z-index: 101; */
`;
const MessageBlock = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 96%;
  transform: translate(-50%, -50%);
  padding: 25px 10px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #ffffff;
`;
const Message = styled.div`
  text-align: center;
  padding-bottom: 12px;
  padding-top: 20px;
`;
const ActionButton = styled.div`
  width: 100%;
  max-width: 200px;
  margin: 10px auto;
  background: #003e8d;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
`;
const CardTitle=styled.div`
font-weight: bold;
padding: 3px 0px;
`;
const CloseButton=styled.span`
    position: absolute;
    top: 0px;
    right: 10px;
    padding: 5px;
    color: #003E8D;
    font-size: 30px;
    font-weight: bold;
    transition: 0.3s;
    &:hover,:focus{
    color: red;
    text-decoration: none;
    cursor: pointer;
    }
`
const Button=styled.div`
    background: #003E8D;
    width: 95%;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    margin: 10px auto;
`;


export default class BlockCreditCard extends Component {
  state={
    masterSwitch:false,
    cardData:[],
    previousToggle:"",
    showButton:false,
    showOverlay:false,
    slaveToggle:false,
  }
  componentDidMount(){
    let arr=[];
    this.props.cardData.forEach((data,index)=>{
      data.toggle_status === true?arr.push("Y"):arr.push("N");
    });
    //always we need to do destructuring for all the levels in array of objects
    //otherwise it will create issue in some where
    let arr1=[...this.props.cardData].map((data,index)=>{
      return {...data};
    })
    this.setState({masterSwitch:this.props.masterSwitch,cardData:arr1,previousToggle:arr.join("")});
  
  }

  handleToggle = (index)=>{
    let data=[...this.state.cardData].map((val)=>{
      return {...val};
    });
    data[index-1].toggle_status = !data[index-1].toggle_status;
    let arr=[];
    data.forEach((value,index)=>{
      value.toggle_status === true?arr.push("Y"):arr.push("N");
    });
    let str=arr.join("");

    let mainSwitch =false;
    if(str === "NNNN"){
      mainSwitch=false;
    }else if(str === "YYYY" || arr.includes("Y")){
      mainSwitch=true;
    }

    let saveButtonShow=true;
    if(this.state.previousToggle === str){
      saveButtonShow=false;
    }
    this.setState({cardData:data,showButton:saveButtonShow,slaveToggle:true, masterSwitch:mainSwitch});
  }
  handleMasterToggle = () =>{
    let masterData=[...this.state.cardData].map((data)=>{
      return {...data,toggle_status:!this.state.masterSwitch};
    });
    if(this.state.masterSwitch === true){
      this.setState({masterSwitch:!this.state.masterSwitch,showButton:false,cardData:masterData,showOverlay:true},()=>{
        if(this.state.masterSwitch === this.props.masterSwitch){
          let arr=[...this.props.cardData].map((data,index)=>{
            return {...data};
          })
          this.setState({showOverlay:false,cardData:arr});
        }
      });
      
    }else{
      this.setState({masterSwitch:!this.state.masterSwitch,showButton:true,cardData:masterData});
    }
   
  }
  handleExit=(data)=>{
    let sendData= {"userResponse":""};
    let noChange=false;
    if(data === "Yes"){
      sendData.userResponse = "switchOff";
    }else{
      sendData.userResponse = "No";
      noChange=true;
    };
    let inputString = data + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);
    if(noChange === true){
      this.handleClick();
    }else{
      this.setState({showOverlay:false});
    } 
  }
  handleChanges = ()=>{
    let sendData = null;
    if(this.state.masterSwitch === true){
      sendData= {"userResponse":"switchOn"};
    }else if(this.state.masterSwitch === false){
      sendData={"userResponse":"switchOff"}
    }
    if(this.state.slaveToggle === true){
      let arr=[];
      this.state.cardData.forEach((data,index)=>{
        data.toggle_status === true?arr.push("Y"):arr.push("N");
      });
      let obj={
        "INTERNATIONAL_ONOFF_FLAG":arr[0],
        "POS_ONOFF_FLAG":arr[1],
        "ONLINE_ONOFF_FLAG":arr[2],
        "ATM_ONOFF_FLAG":arr[3],
      };
      sendData= {"userResponse":obj};
    }
    let inputString = "Proceed" + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);
  }
  handleCancel = ()=>{
    let sendData = {"userResponse":"Cancel"};
    let inputString = "Cancel" + "<split>" + JSON.stringify(sendData);
    window["autosubmit"](inputString);
    this.handleClick();
  }
  handleClick =()=>{
    let arr=[...this.props.cardData].map((data,index)=>{
      return {...data};
    })
    this.setState({showOverlay:false,cardData:arr,masterSwitch:this.props.masterSwitch})
  }
  render(){
  return (
    <MainWrapper className="disable-item">
      <MasterToggle>
  <CardTitle style={{padding:"3px 8px 0px 0px"}}>{this.state.masterSwitch?"SWITCH OFF CARD":"SWITCH ON CARD"}</CardTitle>
        <Toggle>
          <MasterInput type="checkbox" checked={this.state.masterSwitch} onChange={this.handleMasterToggle} />
          <Slider></Slider>
        </Toggle>
      </MasterToggle>
      <CardContainer>
        {this.state.cardData.map((data, index) => {
          return (
            <CardWrapper key={data.cardId}>
              <Title>
                <CardTitle>{data.title}</CardTitle>
                <Tooltip>i<TooltipText >{data.tooltip_text}</TooltipText></Tooltip>
              </Title>
              <Toggle>
                <SlaveInput type="checkbox" checked={data.toggle_status} onChange={()=>{this.handleToggle(data.cardId)}}/>
                <Slider></Slider>
              </Toggle>
            </CardWrapper>
          );
        })}
      </CardContainer>
      {this.state.showButton?<Button className="disable-item"  onClick={this.handleChanges}>Save Changes</Button>:null}
      <Button className="disable-item"  onClick={this.handleCancel}>Cancel</Button>
      {this.state.showOverlay?
      <OverlayBlock className="disable-item">
      <MessageBlock>
      <CloseButton className="close" onClick={this.handleClick}>&times;</CloseButton>
        <Message><b>Do you really want to switch off your Card? </b><br></br>(Any purchases attempted in Switch Off mode will be declined)</Message>
        <ActionButton onClick={()=>{this.handleExit("Yes")}}>Yes, I’m sure</ActionButton>
        <ActionButton onClick={()=>{this.handleExit("No")}}>No, I did this by mistake</ActionButton>
      </MessageBlock>
    </OverlayBlock>:null}
    </MainWrapper>
  );
  }
};

